//  mutaciones son sincronas y hacen modificaciones del state


export const listEstanciasAlum = (state, estancias) => {
  state.estanciasAlum = [...estancias];
  state.isLoading = false;
};

export const traeSemestres = (state, semesters) => {
  if (semesters.length !== 0) {
    state.semesters = [...semesters];
    state.isLoading = false;
  }
  state.isLoading = false;
};

export const traeDocumentos = (state, documentacion) => {
  if (documentacion && documentacion.length !== 0) {
    state.documentacion = [...documentacion];
    state.isLoading = false;
  }
  state.isLoading = false;
};


export const verificaDocumentacion = (state,documentos) => {
  if(documentos && documentos.length === 5){
    localStorage.setItem("tieneDocs", "Si");
    state.tipoCarga = 'R'
  } else {
    localStorage.setItem("tieneDocs", "No");
    state.tipoCarga = 'S'
  }
}

export const setSubioDocs = (state,values) => {
  state.subioDocs = values
}

export const setMensaje = (state,values) => {
  state.mostrarMensaje = values
}


export const setCosntancia = (state,values) => {
  sessionStorage.setItem("constancia", values);
  state.constancia = values
}
